<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Search</strong></h4>
      <a href="https://mdbootstrap.com/vue/components/search/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr />
    <container>
      <h3 class="my-5">Search with buttons</h3>
      <form-inline class="mr-auto mb-4">
        <mdb-input class="mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
        <btn gradient="aqua" rounded size="sm" type="submit" class="mr-auto">Search</btn>
        <mdb-input class="mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
        <btn outline color="warning" rounded size="sm" type="submit" class="mr-auto">Search</btn>
        <mdb-input class="mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
        <btn color="unique" rounded size="sm" type="submit" class="mr-auto">Search</btn>
      </form-inline>
      <form class="form-inline mr-auto">
        <input class="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
        <btn gradient="aqua" rounded size="sm" type="submit" class="mr-auto">Search</btn>
        <input class="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
        <btn outline color="warning" rounded size="sm" type="submit" class="mr-auto">Search</btn>
        <input class="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
        <btn color="unique" rounded size="sm" type="submit" class="mr-auto">Search</btn>
      </form>
      <h3 class="my-5">Search within navbar</h3>
      <navbar dark class="indigo">
        <mdb-navbar-brand href="#">Navbar</mdb-navbar-brand>
        <navbar-collapse>
          <navbar-nav right>
            <form-inline class="ml-auto">
              <mdb-input class="mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
              <btn size="sm" type="submit" class="mr-auto" outline="white">Search</btn>
            </form-inline>
          </navbar-nav>
        </navbar-collapse>
      </navbar>
      <br/>
      <navbar class="blue-grey lighten-5">
        <mdb-navbar-brand href="#">Navbar</mdb-navbar-brand>
        <navbar-collapse>
          <navbar-nav>
            <navbar-item active>Home</navbar-item>
            <navbar-item>Features</navbar-item>
            <navbar-item>Pricing</navbar-item>
            <!-- Dropdown -->
            <dropdown tag="li" class="nav-item">
              <dropdown-toggle slot="toggle" tag="a" navLink color="blue-gray" waves-fixed>Dropdown</dropdown-toggle>
              <dropdown-menu>
                <dropdown-item>Action</dropdown-item>
                <dropdown-item>Another action</dropdown-item>
                <dropdown-item>Something else here</dropdown-item>
              </dropdown-menu>
            </dropdown>
          </navbar-nav>
          <navbar-nav right>
            <form-inline class="ml-auto">
              <mdb-input class="mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
            </form-inline>
          </navbar-nav>
        </navbar-collapse>
      </navbar>
      <br/>
      <navbar dark class="teal lighten-2">
        <mdb-navbar-brand href="#">Navbar</mdb-navbar-brand>
        <navbar-collapse>
          <navbar-nav right>
            <form-inline class="ml-auto">
              <mdb-input class="mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
            </form-inline>
          </navbar-nav>
        </navbar-collapse>
      </navbar>
      <br/>
      <navbar dark class="pink lighten-3" href="#/">
        <navbar-collapse>
          <navbar-nav>
            <form-inline class="ml-auto">
              <mdb-input class="mr-sm-2" type="text" placeholder="Search" aria-label="Search"/>
              <fa icon="search" class="white-text"/>
            </form-inline>
          </navbar-nav>
        </navbar-collapse>
        <mdb-navbar-brand style="order: 3" href="#">Navbar</mdb-navbar-brand>
      </navbar>
      <br/>
      <navbar dark class="blue lighten-3" href="#/">
        <navbar-collapse>
          <navbar-nav>
            <form-inline class="ml-auto">
              <mdb-input class="mr-sm-2" type="text" placeholder="Search" aria-label="Search"/>
              <btn color="mdb-color" rounded size="sm" class="mr-auto">Search</btn>
            </form-inline>
          </navbar-nav>
        </navbar-collapse>
        <mdb-navbar-brand style="order: 3" href="#">Navbar</mdb-navbar-brand>
      </navbar>
      <h3 class="my-5">Search within select</h3>
      <mdb-select search @getValue="getSelectValue">
        <option disabled selected>Choose your option</option>
        <option value="Option 1">Option nr 1</option>
        <option value="Option 2">Option nr 2</option>
        <option value="Option 3">Option nr 3</option>
        <option value="Option 4">Option nr 4</option>
        <option value="Option 5">Option nr 5</option>
      </mdb-select>
      <label>Example label</label>
      <h3 class="my-5">Search within multiselect</h3>
      <mdb-select multiple search @getValue="getSelectValue">
        <option disabled selected>Choose your options</option>
        <option value="Option 1">Option nr 1</option>
        <option value="Option 2">Option nr 2</option>
        <option value="Option 3">Option nr 3</option>
        <option value="Option 4">Option nr 4</option>
        <option value="Option 5">Option nr 5</option>
      </mdb-select>
      <label>Example label</label>
      <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
    </container>
  </container>
</template>

<script>
import { Container, mdbInput, FormInline, Btn, Navbar, NavbarCollapse, NavbarNav, NavbarItem, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Fa, mdbSelect, mdbNavbarBrand, Row } from 'mdbvue';

export default {
  name: 'MasksPage',
  components: {
    Container,
    mdbInput,
    FormInline,
    Btn,
    Navbar,
    NavbarCollapse,
    NavbarNav,
    NavbarItem,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Fa,
    mdbSelect,
    mdbNavbarBrand,
    Row
  },
  methods: {
    getSelectValue(value) {
      console.log(value);
    }
  }
};
</script>

<style scoped>
</style>
